import { render, staticRenderFns } from "./VeePdfViewer.vue?vue&type=template&id=c7aaa840&scoped=true"
import script from "./VeePdfViewer.vue?vue&type=script&lang=js"
export * from "./VeePdfViewer.vue?vue&type=script&lang=js"
import "./VeePdfViewer.vue?vue&type=style&index=0&id=c7aaa840&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7aaa840",
  null
  
)

export default component.exports